var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.18133 5.02127C13.0487 4.5926 16.9515 4.5926 20.8188 5.02127C22.9601 5.26127 24.6876 6.94752 24.9388 9.09627C25.3976 13.0187 25.3976 16.9813 24.9388 20.9038C24.6876 23.0525 22.9601 24.7388 20.8188 24.9788C16.9515 25.4075 13.0486 25.4075 9.18133 24.9788C7.04008 24.7388 5.31258 23.0525 5.06133 20.9038C4.6026 16.9817 4.6026 13.0196 5.06133 9.09752C5.18841 8.05361 5.6643 7.0832 6.41187 6.34358C7.15944 5.60395 8.13487 5.13845 9.18008 5.02252M15.0001 8.75877C15.2487 8.75877 15.4872 8.85754 15.663 9.03336C15.8388 9.20917 15.9376 9.44763 15.9376 9.69627V14.0625H20.3038C20.5525 14.0625 20.7909 14.1613 20.9667 14.3371C21.1426 14.5129 21.2413 14.7514 21.2413 15C21.2413 15.2487 21.1426 15.4871 20.9667 15.6629C20.7909 15.8387 20.5525 15.9375 20.3038 15.9375H15.9376V20.3038C15.9376 20.5524 15.8388 20.7909 15.663 20.9667C15.4872 21.1425 15.2487 21.2413 15.0001 21.2413C14.7514 21.2413 14.513 21.1425 14.3372 20.9667C14.1614 20.7909 14.0626 20.5524 14.0626 20.3038V15.9375H9.69633C9.44769 15.9375 9.20923 15.8387 9.03342 15.6629C8.8576 15.4871 8.75883 15.2487 8.75883 15C8.75883 14.7514 8.8576 14.5129 9.03342 14.3371C9.20923 14.1613 9.44769 14.0625 9.69633 14.0625H14.0626V9.69627C14.0626 9.44763 14.1614 9.20917 14.3372 9.03336C14.513 8.85754 14.7514 8.75877 15.0001 8.75877Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.c8034171500d031406b1dfeb37151c7a.svg";
export { ForwardRef as ReactComponent };